import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import bindAllOfThis from 'src/utils/BindThisHelper';
import { PageProps } from "src/models/common/ComponentProps";
import { Icon } from "antd";
import { Translate } from 'react-localize-redux';
import Config from "src/constants/Config";
import { UserState } from 'src/redux/UserReducer';
import { withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { ReduxStoreModel } from 'src/redux/ReduxModel';
import { connect } from 'react-redux';

interface AzureFileDisplay {
    name: string;
    extension: string;

    // Generated
    url: string;
    iconName: string;
    fileName: string;
}

interface DownloadableResourcesProps extends PageProps<{}>, LocalizeContextProps {
    User: UserState;
}

class DownloadableResources extends React.Component<DownloadableResourcesProps> {
    files: AzureFileDisplay[] = [];
    constructor(props: DownloadableResourcesProps) {
        super(props);
        bindAllOfThis(this, DownloadableResources.prototype);

        // Load all azure bob urls
        let files: AzureFileDisplay[] = [
            { name: "Galaxy Administrator Login Instructions", extension: "pdf" } as AzureFileDisplay,
            { name: "Galaxy Adding Students Tool Tips", extension: "pdf" } as AzureFileDisplay,
            { name: "Galaxy Quick Guide", extension: "pdf" } as AzureFileDisplay,
            { name: "Galaxy Student Login Card", extension: "pdf" } as AzureFileDisplay,
            { name: "Galaxy Flier", extension: "pdf" } as AzureFileDisplay,
            { name: "RIASEC Poster", extension: "pdf" } as AzureFileDisplay,
            { name: "Parent Communication Template", extension: "docx" } as AzureFileDisplay,
            { name: "Parent Communication Template - Spanish Version", extension: "docx"} as AzureFileDisplay,
            { name: "Galaxy Poster 18X24", extension: "pdf" } as AzureFileDisplay,
            { name: "Galaxy Badge Worksheets", extension: "pdf" } as AzureFileDisplay,
        ];

        let getIconFromExtension = (extension) => {
            switch (extension) {
                case "pdf":
                    return "file-pdf";
                case "docx":
                    return "file-word";
                case "jpg":
                    return "file-jpg";
                default:
                    return "file-unknown";
            }
        };

        this.files = files.map(x => {
            let fileName = `${x.name}.${x.extension}`;
            return {
                ...x,
                url: Config.GetAzureUrl(fileName, "static", this.props.User.cultureCode),
                iconName: getIconFromExtension(x.extension),
                fileName: fileName};
        });
    }

    render() {
        return <div className="downloadable-resources">
            <h2><Translate id="admin.resources.header" /></h2>
            {this.files.map(x => (<p key={x.fileName}>
                <Icon type={x.iconName} /> <a href={x.url}>{x.name}</a>
            </p>))}
        </div>;
    }
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        User: state.User
    };
}

export default connect(mapStateToProps)(withLocalize(DownloadableResources));



// WEBPACK FOOTER //
// ./src/pages/admin/DownloadableResources.tsx